import * as types from 'actions/actionTypes';

export const isLoading = () => ({ type: types.PAGE.LOADING });

export const isNotLoading = () => ({ type: types.PAGE.ACTION });
